var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 14h-4a1 1 0 1 1 0-2h4a1 1 0 1 1 0 2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5a1 1 0 1 1 0 2v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V7a1 1 0 0 1 0-2h3V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1h3ZM8 19h8V7H8v12Z"
  })));
};
export { SvgDelete as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9ImN1cnJlbnRDb2xvciIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQgMTRoLTRhMSAxIDAgMSAxIDAtMmg0YTEgMSAwIDEgMSAwIDJaIi8+PHBhdGggZD0iTTE4IDVhMSAxIDAgMSAxIDAgMnYxMmEyIDIgMCAwIDEtMiAySDhhMiAyIDAgMCAxLTItMlY3YTEgMSAwIDAgMSAwLTJoM1Y0YTEgMSAwIDAgMSAxLTFoNGExIDEgMCAwIDEgMSAxdjFoM1pNOCAxOWg4VjdIOHYxMloiLz48L3N2Zz4=";